module.exports = __webpack_public_path__ + "img/arrow_search.34b16121.svg";